<template>
  <section>
    <el-divider content-position="left">任务列表</el-divider>
    <el-row type="flex" :gutter="10">
      <el-col :span="3">
        <el-input
          v-model="RecipeTaskPageInfo.key"
          placeholder="编号/标题/工程/客户"
          @change="getGetRecipeTask(1)"
        ></el-input>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="RecipeTaskPageInfo.orgCode"
          filterable
          placeholder="请选择"
          @change="getGetRecipeTask(1)"
        >
          <el-option
            v-for="item in orgList"
            :key="item.OrgCode + 'Seach'"
            :label="item.Name"
            v-model="item.OrgCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="10">
        <el-date-picker
          type="datetime"
          placeholder="计划时间"
          v-model="RecipeTaskPageInfo.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        -
        <el-date-picker
          type="datetime"
          placeholder="计划时间"
          v-model="RecipeTaskPageInfo.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="RecipeTaskPageInfo.isRecipe"
          placeholder="请选择状态"
          @change="getGetRecipeTask(1)"
        >
          <el-option label="所有" :value="-1"></el-option>
          <el-option label="已做配比" :value="0"></el-option>
          <el-option label="未做配比" :value="100"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="getGetRecipeTask(1)">查询</el-button>
      </el-col>
    </el-row>
    <el-table
      :data="RecipeTaskTable"
      @selection-change="handleSelectionChange"
      style="width: 100%"
      :border="true"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="编号" width="180" fixed>
        <template slot-scope="scope">
          <el-link type="primary" @click="handleTaskDetail(scope.row)">
            {{ scope.row.Code }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="ClientName" label="客户名称"></el-table-column>
      <el-table-column prop="ProjectName" label="工程名称"></el-table-column>
      <el-table-column prop="ProjectPart" label="施工部位"></el-table-column>
      <el-table-column prop="GradeName" label="标号/特殊材料">
        <template slot-scope="scope">
          <span>
            {{ scope.row.GradeName
            }}{{ scope.row.SpecMtlName ? "/" + scope.row.SpecMtlName : "" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="WorkMethodName" label="浇筑方式"></el-table-column>
      <el-table-column prop="PlanDate" label="计划时间"></el-table-column>
      <el-table-column prop="PlanQuantity" label="计划/完成量">
        <template prop="PlanQuantity" slot-scope="scope">
          <span>
            {{ scope.row.PlanQuantity }}/{{ scope.row.QuantityTotal }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="RecipeCodes" label="配方名称">
        <template prop="RecipeCodes" slot-scope="scope">
          <span
            v-for="item in getRecipeCodesInString(scope.row.RecipeCodes)"
            :key="item.StationLineID"
          >
            <el-link
              type="primary"
              @click="handleDetailById(item)"
              style="margin: 0 5px"
            >
              {{ item.StationLineName }}({{ item.RecipeTitle }})
            </el-link>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="RecipeTaskPageInfo.pageSize"
      :total="RecipeTaskPageInfo.total"
      @current-change="handleCurrentChange($event, 1)"
      @size-change="handleSizeChange($event, 1)"
      class="my-pagination"
    ></el-pagination>
    <el-divider content-position="left">配方列表</el-divider>
    <el-row type="flex" :gutter="10">
      <el-col :span="3">
        <el-input placeholder="配比标题" v-model="PBseachDm.Title"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input
          placeholder="强度等级"
          v-model="PBseachDm.GradeName"
        ></el-input>
      </el-col>
      <el-col :span="4">
        <el-button
          type="primary"
          @click="
            () => {
              ProdRecipeTablePageInfo.page = 1;
              getProdRecipeGet();
            }
          "
        >
          查询
        </el-button>
      </el-col>
    </el-row>
    <el-tabs
      v-model="activeName"
      @tab-click="changeProdRecipeTableTab"
      type="card"
    >
      <el-tab-pane
        :label="line.Name"
        v-for="line in SysStationLineList"
        :key="line.Id"
        :name="line.Id"
      >
        <el-table
          :data="ProdRecipeTable.filter((x) => x.StationLineID == line.Id)"
          style="width: 100%"
          @current-change="changeProdRecipeRow"
          :border="true"
        >
          <el-table-column prop="Title" label="单选">
            <template slot-scope="scope">
              <el-radio
                @change="showBandData($event, scope)"
                v-model="selectProdRecipeRow"
                :label="scope.row.Id"
              >
                {{ scope.row.Title }}
              </el-radio>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="Title" label="名称"></el-table-column> -->
          <el-table-column prop="GradeName" label="强度等级"></el-table-column>
          <el-table-column
            prop="SpecMtlName"
            label="特殊材料"
          ></el-table-column>
          <el-table-column prop="TLD" label="塌落度"></el-table-column>
          <el-table-column prop="SSL" label="砂率">
            <template slot-scope="scope">
              <span>
                {{ scope.row.TSL
                }}{{ scope.row.SSL ? "/" + scope.row.SSL : "" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="SSJB" label="水胶比">
            <template slot-scope="scope">
              <span>
                {{ scope.row.TSJB
                }}{{ scope.row.SSJB ? "/" + scope.row.SSJB : "" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="SSJB" label="A">
            <template slot-scope="scope">
              <span>
                {{ scope.row.TAProportion
                }}{{
                  scope.row.SAProportion ? "/" + scope.row.SAProportion : ""
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="SSJB" label="K">
            <template slot-scope="scope">
              <span>
                {{ scope.row.TKProportion
                }}{{
                  scope.row.SKProportion ? "/" + scope.row.SKProportion : ""
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="SSJB" label="F">
            <template slot-scope="scope">
              <span>
                {{ scope.row.TFProportion
                }}{{
                  scope.row.SFProportion ? "/" + scope.row.SFProportion : ""
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-link type="primary" @click="handleDetail(scope.row)">
                详情
              </el-link>
              <el-link
                :type="scope.row.Transfer == 1 ? 'primary' : 'danger'"
                @click="
                  () => {
                    currentRow = scope.row;
                    sendRecipeFunc();
                  }
                "
              >
                {{ scope.row.Transfer == 1 ? "已传送" : "待传送" }}
              </el-link>
              <el-link
                type="primary"
                @click="
                  () => {
                    currentRow = scope.row;
                    handleHistry();
                  }
                "
              >
                历史
              </el-link>
              <el-link
                type="primary"
                @click="
                  () => {
                    currentRow = scope.row;
                    handleTaskHistry();
                  }
                "
              >
                所关联任务
              </el-link>
              <el-link
                type="primary"
                @click="
                  () => {
                    currentRow = scope.row;
                    handleEdit();
                  }
                "
              >
                编辑
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="ProdRecipeTablePageInfo.pageSize"
          :total="ProdRecipeTablePageInfo.total"
          @current-change="handleCurrentChange($event, 2)"
          @size-change="handleSizeChange($event, 2)"
          class="my-pagination"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
    <!-- 历史配比列表 -->
    <el-dialog
      title="历史配比列表"
      :visible.sync="histryShow"
      v-model="histryShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <!--历史列表-->
      <el-table
        :data="histryData"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
      >
        <el-table-column label="标题">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleDetail(scope.row)">
              {{ scope.row.Title }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="GradeName"
          label="强度等级"
          sortable
        ></el-table-column>
        <el-table-column
          prop="SpecMtlName"
          label="特殊材料名称"
          sortable
        ></el-table-column>
        <el-table-column
          prop="WorkMethodName"
          label="浇筑方式"
          sortable
        ></el-table-column>
        <el-table-column prop="Transfer" label="传送状态" width="">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Transfer == 1 ? 'success' : 'info'"
              disable-transitions
            >
              {{ scope.row.Transfer == 1 ? "已传送" : "未传送" }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="histrypageSize"
        :total="histrytotal"
        @current-change="histryCurrentChange"
        @size-change="histrySizeChange"
        class="my-pagination"
      ></el-pagination>
    </el-dialog>

    <!-- 配方详情 -->
    <el-dialog
      :title="
        ProdRecipeDetail.ProdRecipe.StationLine +
        '--' +
        ProdRecipeDetail.ProdRecipe.Title
      "
      :visible.sync="isShowProdRecipeDetailPage"
    >
      <h4>混凝土配比</h4>
      <el-table
        :data="
          ProdRecipeDetail.ProdRecipeSubList.filter((x) => x.RecipeType == 1)
        "
      >
        <el-table-column prop="MatName" label="物资名称"></el-table-column>
        <el-table-column
          prop="WarehouseName"
          label="仓库名称"
        ></el-table-column>
        <el-table-column prop="MatGrade" label="物资规格"></el-table-column>
        <el-table-column prop="Quantity" label="理论用量"></el-table-column>
        <el-table-column
          prop="ActualQuantity"
          label="实际用量"
        ></el-table-column>
      </el-table>
      <h4>砂浆配比</h4>
      <el-table
        :data="
          ProdRecipeDetail.ProdRecipeSubList.filter((x) => x.RecipeType == 2)
        "
      >
        <el-table-column prop="MatName" label="物资名称"></el-table-column>
        <el-table-column
          prop="WarehouseName"
          label="仓库名称"
        ></el-table-column>
        <el-table-column prop="MatGrade" label="物资规格"></el-table-column>
        <el-table-column prop="Quantity" label="理论用量"></el-table-column>
        <el-table-column
          prop="ActualQuantity"
          label="实际用量"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="上传确认" :visible.sync="isShowBandData">
      <el-divider content-position="left">任务列表</el-divider>
      <el-tag
        v-for="item in SelectRecipeTaskList"
        :key="item.Id"
        style="margin: 5px"
      >
        {{ item.Code }}
      </el-tag>
      <el-divider content-position="left">配方</el-divider>
      <el-tag style="margin: 5px">
        {{ recipeTitle }}
      </el-tag>
      <br />
      <el-row style="text-align: right">
        <el-button type="primary" @click.native="bindRecipeSubmit">
          提交
        </el-button>
      </el-row>
    </el-dialog>

    <!-- 配比所关联的任务列表 -->
    <el-dialog
      title="关联任务列表"
      :visible.sync="histryTaskShow"
      v-model="histryTaskShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <!--关联任务列表-->
      <el-table
        :data="histryTaskData"
        highlight-current-row
        v-loading="listTaskLoading"
        style="width: 100%"
      >
        <el-table-column label="任务编号" width="175">
          <template slot-scope="scope">
            <el-link
              type="primary"
              @click="
                () => {
                  handleTaskDetail(scope.row);
                }
              "
            >
              {{ scope.row.Code }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="ProjectName"
          label="工程名称"
          sortable
        ></el-table-column>
        <el-table-column
          prop="ClientName"
          label="客户名称"
          sortable
        ></el-table-column>
        <el-table-column
          prop="CreateUser"
          label="创建人"
          sortable
        ></el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建时间"
          sortable
        ></el-table-column>
      </el-table>

      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="histryTaskpageSize"
        :total="histryTasktotal"
        @current-change="histryTaskCurrentChange"
        @size-change="histryTaskSizeChange"
        class="my-pagination"
      ></el-pagination>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="isShowDetail"
      v-model="isShowDetail"
      :close-on-click-modal="false"
      append-to-body
    >
      <table class="table-bordered" style="">
        <tr>
          <th>任务标题</th>
          <td>{{ DetailDm.Title }}</td>
          <th>工程名称</th>
          <td>{{ DetailDm.ProjectName }}</td>
        </tr>
        <tr>
          <th>客户名称</th>
          <td>{{ DetailDm.ClientName }}</td>
          <th>运输距离</th>
          <td>{{ DetailDm.Distance }}</td>
        </tr>
        <tr>
          <th>计划方量</th>
          <td>{{ DetailDm.PlanQuantity }}</td>
          <th>计划时间</th>
          <td>{{ DetailDm.PlanDate }}</td>
        </tr>
        <tr>
          <th>塌落度</th>
          <td>{{ DetailDm.TLD }}</td>
          <th>强度等级</th>
          <td>{{ DetailDm.GradeName }} / {{ DetailDm.SpecMtlName }}</td>
        </tr>
        <tr>
          <th>是否泵送</th>
          <td>{{ DetailDm.IsPumping == 1 ? "是" : "否" }}</td>
          <th>浇筑方式</th>
          <td>{{ DetailDm.WorkMethodName }}</td>
        </tr>
        <tr>
          <th>施工地址</th>
          <td>{{ DetailDm.ConstructionAddress }}</td>
          <th>施工部位</th>
          <td>{{ DetailDm.ProjectPart }}</td>
        </tr>
        <tr>
          <th>联系人</th>
          <td>{{ DetailDm.ContactName }}</td>
          <th>联系电话</th>
          <td>{{ DetailDm.ContactPhone }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ DetailDm.Remark }}</td>
        </tr>
      </table>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      :title="isEdit ? '修改' : '新增'"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="配比标题" prop="Title">
          <el-input v-model="addForm.Title" auto-complete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="强度等级">
              <el-select
                v-model="addForm.GradeID"
                filterable
                placeholder="请选择"
                @change="selectGrade"
              >
                <el-option
                  v-for="item in baseData.GradeList"
                  :key="item.Id + '_Grade'"
                  :label="item.Name"
                  :value="item.Id"
                  v-model="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="浇筑方式">
              <el-select
                v-model="addForm.WorkMethodID"
                filterable
                placeholder="请选择"
                @change="selectPouringMethod"
              >
                <el-option
                  v-for="item in baseData.PouringMethodList"
                  :key="item.Id + '_Pouring'"
                  :label="item.Name"
                  :value="item.Id"
                  v-model="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="塌落度">
              <el-select
                v-model="addForm.TLD"
                filterable
                placeholder="请选择"
                @change="selectTld"
              >
                <el-option
                  v-for="item in baseData.TldList"
                  :key="item.Id + '_Tld'"
                  :label="item.Name"
                  :value="item.Name"
                  v-model="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="生产线">
              <el-select
                v-model="addForm.StationLineID"
                placeholder="请选择"
                @change="selectStation"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in stationLine"
                  :key="item.Id + '_scx'"
                  :label="item.Name"
                  v-model="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="搅拌时间" prop="TMixTime">
              <el-input
                v-model="addForm.TMixTime"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注" prop="Remark">
              <el-input v-model="addForm.Remark" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="特殊材料">
          <el-checkbox-group v-model="specMtlIDList">
            <el-checkbox
              v-for="item in baseData.SpecialMaterialList"
              :label="item.Id"
              :key="item.Id + '_Special'"
              @change="changeSpecialMaterial(item, $event)"
            >
              {{ item.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <h3>
        混凝土配比 - {{ addForm.TConsultRecipeTitle }}
        <el-button type="primary" @click="dialogType(1)">选择</el-button>
      </h3>
      <el-form>
        <el-row
          :gutter="20"
          type="flex"
          justify="space-around"
          class="row-center"
        >
          <el-col>物资类型</el-col>
          <el-col>仓库</el-col>
          <el-col>物资</el-col>
          <el-col>规格</el-col>
          <el-col>理论用量（千克）</el-col>
          <el-col>实际用量（千克）</el-col>
          <el-col>含水率</el-col>
          <el-col>备注</el-col>
          <el-col>操作</el-col>
        </el-row>
        <el-row
          :gutter="20"
          type="flex"
          justify="space-around"
          v-for="(item, index) in TrecipeSubList"
          :key="index"
        >
          <el-col>
            <el-form-item>
              <el-select
                v-model="item.MatClassName"
                @change="recipeMappingSelectChangeT($event, index)"
                :disabled="item.IsManual == 0"
                filterable
              >
                <el-option
                  v-for="mp in MappingGroupList"
                  :label="mp.MatClassName"
                  :key="mp.Id + '_classId_' + index"
                  :value="mp.MatClassID"
                  v-model="mp.MatClassID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-select
                v-model="item.WarehouseName"
                @change="recipeWhSelectChange($event, index)"
                filterable
              >
                <el-option
                  v-for="wh in MappingList.filter(
                    (e) => e.MatClassName == item.MatClassName
                  )"
                  :label="wh.WarehouseName"
                  :key="wh.WarehouseID + '_whId'"
                  :value="wh.WarehouseID"
                  v-model="wh.WarehouseID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item>
              <el-select
                v-model="item.MatName"
                @change="recipeMatSelectChange($event, index)"
                filterable
              >
                <el-option
                  v-for="material in baseData.MaterialList &&
                  baseData.MaterialList.length > 0 &&
                  baseData.MaterialList.filter(
                    (e) => e.MatClassTypeCode == item.MatTypeCode
                  ).length > 0
                    ? baseData.MaterialList.filter(
                        (e) => e.MatClassTypeCode == item.MatTypeCode
                      )
                    : baseData.MaterialList"
                  :label="material.Name"
                  :key="material.Id + '_matId'"
                  :value="material.Id"
                  v-model="material.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input
                v-model="item.MatGrade"
                auto-complete="off"
                readonly=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input
                v-model="item.Quantity"
                auto-complete="off"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input
                v-model="item.ActualQuantity"
                auto-complete="off"
                @input="changeTquantity"
                :readonly="
                  (item.MatTypeCode == 30 ||
                    item.MatTypeCode == 301 ||
                    item.MatTypeCode == 302) &&
                  item.MoistureContent > 0
                    ? true
                    : false
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input
                v-model="item.MoistureContent"
                auto-complete="off"
                @input="TMoistureContentCalculation"
                v-show="
                  item.MatTypeCode == 30 ||
                  item.MatTypeCode == 301 ||
                  item.MatTypeCode == 302
                    ? true
                    : false
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item style="text-align: center">
              <el-button
                type="danger"
                @click="recipeTableRemoveRowT(item.Id)"
                v-show="item.IsManual == 1"
              >
                删除
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button @click="recipeTableAddRowT">新增行</el-button>
        </el-row>
      </el-form>
      <el-form>
        <el-row
          :gutter="20"
          type="flex"
          justify="space-around"
          class="row-center"
        >
          <el-col>
            <el-form-item label="砂率">
              <el-input v-model="addForm.TSL"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="水胶比">
              <el-input v-model="addForm.TSJB"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="容重">
              <el-input v-model="addForm.TBulkDensity" readonly=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          type="flex"
          justify="space-around"
          class="row-center"
        >
          <el-col>
            <el-form-item label="F掺量">
              <el-input v-model="addForm.TFProportion"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="K掺量">
              <el-input v-model="addForm.TKProportion"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="A掺量">
              <el-input v-model="addForm.TAProportion"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <h3>
        砂浆配比 - {{ addForm.SConsultRecipeTitle }}
        <el-button type="primary" @click="dialogType(2)">选择</el-button>
      </h3>
      <el-form>
        <el-row
          :gutter="20"
          type="flex"
          justify="space-around"
          class="row-center"
        >
          <el-col>物资类型</el-col>
          <el-col>仓库</el-col>
          <el-col>物资</el-col>
          <el-col>规格</el-col>
          <el-col>理论用量（千克）</el-col>
          <el-col>实际用量（千克）</el-col>
          <el-col>含水率</el-col>
          <el-col>备注</el-col>
          <el-col>操作</el-col>
        </el-row>
        <el-row
          :gutter="20"
          type="flex"
          justify="space-around"
          v-for="(item, index) in SrecipeSubList"
          :key="index"
        >
          <el-col>
            <el-form-item>
              <el-select
                v-model="item.MatClassName"
                @change="recipeMappingSelectChangeS($event, index)"
                :disabled="item.IsManual == 0"
                filterable
              >
                <el-option
                  v-for="mp in MappingGroupList"
                  :label="mp.MatClassName"
                  :key="mp.MatClassID"
                  :value="mp.MatClassID"
                  v-model="mp.MatClassID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-select
                v-model="item.WarehouseName"
                @change="recipeWhSelectChangeS($event, index)"
                filterable
              >
                <el-option
                  v-for="wh in MappingList.filter(
                    (e) => e.MatClassName == item.MatClassName
                  )"
                  :label="wh.WarehouseName"
                  :key="wh.WarehouseID"
                  :value="wh.WarehouseID"
                  v-model="wh.WarehouseID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-select
                v-model="item.MatName"
                @change="recipeMatSelectChangeS($event, index)"
                filterable
              >
                <el-option
                  v-for="material in baseData.MaterialList &&
                  baseData.MaterialList.length > 0 &&
                  baseData.MaterialList.filter(
                    (e) => e.MatClassTypeCode == item.MatTypeCode
                  ).length > 0
                    ? baseData.MaterialList.filter(
                        (e) => e.MatClassTypeCode == item.MatTypeCode
                      )
                    : baseData.MaterialList"
                  :label="material.Name"
                  :key="material.Id"
                  :value="material.Id"
                  v-model="material.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input
                v-model="item.MatGrade"
                auto-complete="off"
                readonly=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input
                v-model="item.Quantity"
                auto-complete="off"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input
                v-model="item.ActualQuantity"
                auto-complete="off"
                @input="changeSquantity"
                :readonly="
                  (item.MatTypeCode == 30 ||
                    item.MatTypeCode == 301 ||
                    item.MatTypeCode == 302) &&
                  item.MoistureContent > 0
                    ? true
                    : false
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input
                v-model="item.MoistureContent"
                auto-complete="off"
                @input="SMoistureContentCalculation"
                v-show="
                  item.MatTypeCode == 30 ||
                  item.MatTypeCode == 301 ||
                  item.MatTypeCode == 302
                    ? true
                    : false
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item style="text-align: center">
              <el-button
                type="danger"
                @click="recipeTableRemoveRowS(item.Id)"
                v-show="item.IsManual == 1"
              >
                删除
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button @click="recipeTableAddRowS">新增行</el-button>
        </el-row>
      </el-form>
      <el-form>
        <el-row
          :gutter="20"
          type="flex"
          justify="space-around"
          class="row-center"
        >
          <el-col>
            <el-form-item label="砂率">
              <el-input v-model="addForm.SSL"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="水胶比">
              <el-input v-model="addForm.SSJB"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="容重">
              <el-input v-model="addForm.SBulkDensity" readonly=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          type="flex"
          justify="space-around"
          class="row-center"
        >
          <el-col>
            <el-form-item label="F掺量">
              <el-input v-model="addForm.SFProportion"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="K掺量">
              <el-input v-model="addForm.SKProportion"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="A掺量">
              <el-input v-model="addForm.SAProportion"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <TableDataDialog
      title="理论配比选择"
      :visibleDiaInitQuery="visibleDiaInitQuery"
      :visibleDialog="visibleDialog"
      :queryMethod="queryData"
      :columns="{
        Title: {
          label: '配比名称',
        },
        WorkMethodName: {
          label: '浇筑方式',
        },
        GradeName: {
          label: '强度等级',
        },
        RecipeType: {
          label: '配比类型',
          filter: (item) => {
            return item.RecipeType == 1 ? '混凝土' : '砂浆';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="setVisible"
      @callback="dialogCallback"
    ></TableDataDialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getGetRecipeTask,
  getProdRecipeGet,
  getProdRecipeDetail,
  getSysStationLineListPage,
  sendTask,
} from "../../api/RecipeMappingTask";
import { sendRecipe, getHistryByPage } from "../../api/prodRecipe";
import { getTaskByRecipeCode } from "../../api/prodTask";
import * as api from "../../api/prodRecipe";
import {
  getConsultRecipeListPage,
  getConsultRecipeDetail,
} from "../../api/recipe";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";

export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      RecipeTaskTable: [],
      ProdRecipeTable: [],
      ProdRecipeDetail: {
        ProdRecipeSubList: [],
        ProdRecipe: {},
      },
      SysStationLineList: [],
      SelectRecipeTaskList: [], //选中的任务
      SelectRecipe: {}, //选中的配方
      isShowProdRecipeDetailPage: false,
      selectProdRecipeRow: "",
      activeName: "",
      isShowBandData: false,
      recipeid: "", // 选中配方Id
      recipeTitle: "", // 选中配方标题
      RecipeTaskPageInfo: {
        page: 1,
        intPageSize: 10,
        isRecipe: 100,
      },
      ProdRecipeTablePageInfo: {
        page: 1,
        intPageSize: 10,
        gradeName: "",
        title: "",
      },
      orgList: JSON.parse(localStorage.sysOrgs),
      histryData: [], //历史记录
      histrytotal: 0, //历史记录翻页
      histrypage: 1,
      histrypageSize: 20,
      histryShow: false,
      listLoading: false,
      PBseachDm: {
        Title: "",
        GradeName: "",
      },
      histryTaskData: [], //合同历史记录
      histryTasktotal: 0, //合同历史记录翻页
      histryTaskpage: 1,
      histryTaskpageSize: 20,
      histryTaskShow: false,
      listTaskLoading: false,
      isShowDetail: false,
      DetailDm: {},

      baseData: [], //任务单基础数据

      specMtlIDList: [],
      specMtlID: [],
      specMtlName: [],
      stationLineID: "",
      stationLine: null,
      addFormVisible: false,
      addForm: {},
      addFormRules: {
        Title: [{ required: true, message: "请输入配比名称", trigger: "blur" }],
      },
      TrecipeSubList: [], //混凝土子表信息
      SrecipeSubList: [], //砂浆子表信息
      visibleDialog: false,
      visibleDiaInitQuery: "",
      openType: 1, //打开选择理论配比类型：1混凝土 2 砂浆
      isEdit: false, //是否为编辑 true为编辑 默认新增
      MappingList: [], //配比映射
      MappingGroupList: [], //配比映射显示
    };
  },

  computed: {
    taskIds() {
      return this.SelectRecipeTaskList.map((x) => x.Id).join(",");
    },
  },
  watch: {
    isShowBandData(value) {
      if (!value) {
        this.selectProdRecipeRow = "";
      }
    },
  },
  mounted() {
    /*获取任务单基础档案*/
    if (localStorage.currentOrg) {
      this.RecipeTaskPageInfo.orgCode = JSON.parse(
        localStorage.currentOrg
      ).OrgCode;
      this.orgId = JSON.parse(localStorage.currentOrg).Id;
    } else if (localStorage.sysOrgs) {
      this.RecipeTaskPageInfo.orgCode = JSON.parse(
        localStorage.sysOrgs
      )[0].OrgCode;
      this.orgId = JSON.parse(localStorage.currentOrg).Id;
    }
    /*获取任务单基础档案*/

    this.init();
  },

  methods: {
    init() {
      this.getGetRecipeTask();
      // this.getProdRecipeGet();
      this.getSysStationLineListPage(true);
      /*获取任务单基础档案*/
      this.getSysStationLineList();
      /*获取任务单基础档案*/
      this.getProdRecipe();
    },
    // 选中配方的任务
    handleSelectionChange(data) {
      this.SelectRecipeTaskList = data;
    },
    //格式化RecipeCodes
    getRecipeCodesInString(str) {
      if (str && str != "-1") {
        return JSON.parse(str);
      }
      return {};
    },
    // 获取任务
    getGetRecipeTask(optype) {
      if (optype == 1) {
        this.RecipeTaskPageInfo.page = 1;
      }
      let para = this.RecipeTaskPageInfo;
      getGetRecipeTask(para).then((data) => {
        if (!data.data.success) {
          this.RecipeTaskTable = [];
          tihs.$message("获取失败");
          return;
        }
        this.RecipeTaskPageInfo.total = data.data.response.dataCount;
        this.RecipeTaskTable = data.data.response.data;
      });
      if (
        (this.PBseachDm.Title != null &&
          this.PBseachDm.Title != undefined &&
          this.PBseachDm.Title.length > 0) ||
        (this.PBseachDm.GradeName != null &&
          this.PBseachDm.GradeName != undefined &&
          this.PBseachDm.GradeName.length > 0)
      ) {
        this.PBseachDm.Title = null;
        this.PBseachDm.GradeName = null;
        this.getProdRecipeGet();
      }
    },
    // 获取生产线 isFrist 第一次进来
    getSysStationLineListPage(isFrist) {
      let para = {
        key: this.orgId,
      };
      getSysStationLineListPage(para).then((data) => {
        if (!data.data.success) {
          this.SysStationLineList = [];
          tihs.$message("获取失败");
          return;
        }
        this.SysStationLineList = data.data.response.data;
        if (
          isFrist &&
          this.SysStationLineList &&
          this.SysStationLineList.length > 0
        ) {
          this.activeName = this.SysStationLineList[0].Id;
          this.getProdRecipeGet(this.SysStationLineList[0].Id);
        }
      });
    },
    //查看历史列表
    handleHistry() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      this.histryShow = true;
      this.getHistry();
    },
    //获取历史列表
    getHistry() {
      let para = {
        page: this.histrypage,
        key: this.currentRow.Code,
        intPageSize: this.histrypageSize,
      };
      this.listLoading = true;
      getHistryByPage(para).then((res) => {
        this.histrytotal = res.data.response.dataCount;
        this.histryData = res.data.response.data;
        this.listLoading = false;
      });
    },
    //查看历史列表
    handleTaskHistry() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      this.histryTaskShow = true;
      this.getTaskHistry();
    },
    //获取关联任务详情
    getTaskHistry() {
      let para = {
        page: this.histryTaskpage,
        key: this.currentRow.Code,
        intPageSize: this.histryTaskpageSize,
      };
      this.listTaskLoading = true;
      getTaskByRecipeCode(para).then((res) => {
        this.histryTasktotal = res.data.response.dataCount;
        this.histryTaskData = res.data.response.data;
        this.listTaskLoading = false;
      });
    },
    //关联任务翻页
    histryTaskCurrentChange() {
      this.page = val;
      this.getTaskHistry();
    },
    //合关联任务切换分页大小绑定方法
    histryTaskSizeChange(size) {
      this.histryTaskpageSize = size;
      this.getTaskHistry();
    },
    // 显示任务详情
    handleTaskDetail(row) {
      this.DetailDm = row;
      this.isShowDetail = !this.isShowDetail;
    },
    // 切换tab
    changeProdRecipeTableTab() {
      this.ProdRecipeTablePageInfo = {
        page: 1,
        intPageSize: 10,
      };
      this.getProdRecipeGet(this.activeName);
    },

    // 获取配方
    getProdRecipeGet(id) {
      let para = this.ProdRecipeTablePageInfo;
      if (id) {
        para.stationLineID = id;
      }
      para.title = this.PBseachDm.Title;
      para.gradeName = this.PBseachDm.GradeName;
      getProdRecipeGet(para).then((data) => {
        if (!data.data.success) {
          this.ProdRecipeTable = [];
          tihs.$message("获取失败");
          return;
        }
        this.ProdRecipeTablePageInfo.total = data.data.response.dataCount;
        this.ProdRecipeTable = data.data.response.data;
      });
    },

    //获取单行数据
    changeProdRecipeRow(current) {
      this.getProdRecipeDetail(current.Id);
    },

    // 显示窗口
    handleDetail(row) {
      this.getProdRecipeDetail(row.Id);
      this.isShowProdRecipeDetailPage = !this.isShowProdRecipeDetailPage;
    },
    // 根据Id显示配比详情显示窗口
    handleDetailById(item) {
      this.getProdRecipeDetail(item.RecipeID);
      this.isShowProdRecipeDetailPage = !this.isShowProdRecipeDetailPage;
      this.PBseachDm.Title = item.RecipeTitle;
      this.PBseachDm.GradeName = "";
      this.activeName = item.StationLineID;
      this.getProdRecipeGet(item.StationLineID);
    },

    // 获取配方详情
    getProdRecipeDetail(id) {
      let para = {
        id: id,
      };
      getProdRecipeDetail(para).then((data) => {
        if (!data.data.success) {
          this.ProdRecipeTable = [];
          tihs.$message("获取失败");
          return;
        }
        this.ProdRecipeDetail = data.data.response;
      });
    },
    // 翻页每页大小改变
    handleSizeChange(size, type) {
      if (type == 1) {
        this.RecipeTaskPageInfo.intPageSize = size;
        this.getGetRecipeTask();
      } else {
        this.ProdRecipeTablePageInfo.intPageSize = size;
        this.getProdRecipeGet();
      }
    },
    //历史配比历史分页大小绑定方法
    histrySizeChange(size) {
      this.histrypageSize = size;
      this.getHistry();
    },
    //翻页事件绑定方法
    handleCurrentChange(val, type) {
      if (type == 1) {
        this.RecipeTaskPageInfo.page = val;
        this.getGetRecipeTask();
      } else {
        this.ProdRecipeTablePageInfo.page = val;
        this.getProdRecipeGet();
      }
    },
    //翻页事件绑定方法
    histryCurrentChange(val, type) {
      this.histrypage = val;
      this.getHistry();
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }

      this.listLoading = true;
      this.dm = {};
      this.specMtlID = [];
      this.specMtlName = [];
      this.TrecipeSubList = [];
      this.SrecipeSubList = [];
      this.isEdit = true;
      let para = {
        id: row.Id,
      };
      api.getProdRecipeDetail(para).then((res) => {
        this.listLoading = false;
        this.MappingList = res.data.response.SysRecipeMappingList;
        this.MappingList.map((e) => {
          if (
            this.MappingGroupList.filter((k) => k.MatClassID == e.MatClassID)
              .length <= 0
          ) {
            this.MappingGroupList.push(e);
          }
        });
        this.addForm = res.data.response.ProdRecipe;
        this.getBaseData(this.addForm.StationLineID, 0);
        let tRecipeSubs = res.data.response.ProdRecipeSubList.filter(
          (e) => e.RecipeType == 1
        );
        if (tRecipeSubs && tRecipeSubs.length > 0) {
          this.TrecipeSubList = tRecipeSubs;
        }
        let sRecipeSubs = res.data.response.ProdRecipeSubList.filter(
          (e) => e.RecipeType == 2
        );
        if (sRecipeSubs && sRecipeSubs.length > 0) {
          this.SrecipeSubList = sRecipeSubs;
        }
        if (
          res.data.response.ProdRecipe.SpecMtlID &&
          res.data.response.ProdRecipe.SpecMtlID.length > 0
        ) {
          this.specMtlID = res.data.response.ProdRecipe.SpecMtlID.split(",");
          this.specMtlName = res.data.response.ProdRecipe.SpecMtlName.split(
            ","
          );
        }

        this.specMtlIDList = this.specMtlID;
        this.addFormVisible = true;
      });
    },
    //执行新增
    addSubmit() {
      var subList = this.TrecipeSubList.concat(this.SrecipeSubList);
      this.addForm = {
        ProdRecipe: this.addForm,
        ProdRecipeSubList: subList,
      };
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editProdRecipe(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getProdRecipeGet();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addFormVisible = false;
              });
          } else {
            api
              .addProdRecipe(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getProdRecipeGet();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addFormVisible = false;
              });
          }
        }
      });
    },
    //获取物资
    getProdRecipe() {
      let para = {
        page: this.page,
        title: this.PBseachDm.Title,
        gradeName: this.PBseachDm.GradeName,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getProdRecipeListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.prodRecipe = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //获取配比所需础信息
    getBaseData(stationLineID, type) {
      let para = {
        stationlineid: stationLineID,
      };
      api.getProdRecipeBaseData(para).then((res) => {
        this.baseData = res.data.response;
        if (type == 1) {
          this.MappingGroupList = [];
          this.TrecipeSubList = [];
          this.SrecipeSubList = [];
          this.addForm.TConsultRecipeTitle = "";
          this.addForm.SConsultRecipeTitle = "";
          this.addForm.TID = 0;
          this.addForm.SID = 0;
          this.addForm.SSL = 0; //砂率
          this.addForm.SSJB = 0; //水胶比
          this.addForm.SFProportion = 0; //F掺量
          this.addForm.SKProportion = 0; //K掺量
          this.addForm.SAProportion = 0; //A掺量
          this.addForm.SBulkDensity = 0;
          this.addForm.TSL = 0; //砂率
          this.addForm.TSJB = 0; //水胶比
          this.addForm.TFProportion = 0; //F掺量
          this.addForm.TKProportion = 0; //K掺量
          this.addForm.TAProportion = 0; //A掺量
          this.addForm.TBulkDensity = 0;
          let appingList = res.data.response.SysRecipeMappingList;
          if (appingList) {
            this.MappingList = appingList;
            this.MappingList.map((e) => {
              if (
                this.MappingGroupList.filter(
                  (k) => k.MatClassID == e.MatClassID
                ).length <= 0
              ) {
                this.MappingGroupList.push(e);
              }
            });
          } else {
            this.MappingList = [];
          }
        }
      });
    },
    //基础配比回调
    getConsultRecipeDetailById(Id) {
      let para = {
        id: Id,
      };
      getConsultRecipeDetail(para).then((res) => {
        var that = this;
        let value = res.data.response.ConsultRecipeSubList,
          consultRecipe = res.data.response.ConsultRecipe;
        if (this.openType == 1) {
          this.addForm.TConsultRecipeTitle = consultRecipe.Title;
          this.addForm.TID = consultRecipe.Id;
          var tsubList = [];
          value.map((v) => {
            var mappingItem = that.MappingList.filter(
              (m) => m.MatClassID == v.MatClassID
            )[0];
            var matItem = that.baseData.MaterialList.filter(
              (mat) => mat.MatClassID == v.MatClassID
            )[0];
            that.subIndex = that.subIndex + 1;
            tsubList.push({
              Id: that.subIndex,
              MatClassID: v.MatClassID,
              MatClassName: v.MatClassName,
              IsManual: 0,
              WarehouseID: mappingItem ? mappingItem.WarehouseID : "",
              WarehouseName: mappingItem ? mappingItem.WarehouseName : "",
              Quantity: v.Quantity,
              ActualQuantity: v.Quantity,
              MatGrade: matItem ? matItem.MatGrade : "",
              MatID: matItem ? matItem.Id : "",
              MatName: matItem ? matItem.Name : "",
              MatTypeCode: matItem ? matItem.MatClassTypeCode : "",
              MoistureContent: 0,
              RecipeType: 1,
            });
          });
          this.TrecipeSubList = tsubList;
        } else {
          this.addForm.SConsultRecipeTitle = consultRecipe.Title;
          this.addForm.SID = consultRecipe.Id;
          var ssubList = [];
          value.map((v) => {
            var mappingItem = that.MappingList.filter(
              (m) => m.MatClassID == v.MatClassID
            )[0];
            var matItem = that.baseData.MaterialList.filter(
              (mat) => mat.MatClassID == v.MatClassID
            )[0];
            that.subIndex = that.subIndex + 1;
            ssubList.push({
              Id: that.subIndex,
              MatClassID: v.MatClassID,
              MatClassName: v.MatClassName,
              IsManual: 0,
              WarehouseID: mappingItem ? mappingItem.WarehouseID : "",
              WarehouseName: mappingItem ? mappingItem.WarehouseName : "",
              Quantity: v.Quantity,
              ActualQuantity: v.Quantity,
              MatGrade: matItem ? matItem.MatGrade : "",
              MatID: matItem ? matItem.Id : "",
              MatName: matItem ? matItem.Name : "",
              MatTypeCode: matItem ? matItem.MatClassTypeCode : "",
              MoistureContent: 0,
              RecipeType: 2,
            });
          });
          this.SrecipeSubList = ssubList;
        }
        this.changeTquantity();
        this.changeSquantity();
        // console.log(this.TrecipeSubList);
      });
    },
    //强度等级选择
    selectGrade(id) {
      var value = this.baseData.GradeList.filter((e) => e.Id == id)[0];
      this.addForm.GradeID = value.Id;
      this.addForm.GradeName = value.Name;
      if (this.addForm.Title == "") {
        this.addForm.Title = value.Name;
      }
    },
    //特殊材料选择
    changeSpecialMaterial(value, isTrue) {
      if (isTrue) {
        this.specMtlID.push(value.Id);
        this.specMtlName.push(value.Name);
      } else {
        this.specMtlID.splice(
          this.specMtlID.findIndex((x) => x === value.Id),
          1
        );
        this.specMtlName.splice(
          this.specMtlName.findIndex((x) => x === value.Name),
          1
        );
      }
      this.addForm.SpecMtlID = this.specMtlID.toString();
      this.addForm.SpecMtlName = this.specMtlName.toString();
    },
    //塌落度选择
    selectTld(id) {
      var value = this.baseData.TldList.filter((e) => e.Id == id)[0];
      this.addForm.TLD = value.Name;
    },
    //浇筑方式选择
    selectPouringMethod(id) {
      var value = this.baseData.PouringMethodList.filter((e) => e.Id == id)[0];
      this.addForm.WorkMethodID = value.Id;
      this.addForm.WorkMethodName = value.Name;
    },
    //生产线选择
    selectStation(id) {
      var value = this.stationLine.filter((e) => e.Id == id)[0];
      this.addForm.StationLineID = id;
      this.addForm.StationLine = value.Name;
      this.getBaseData(this.addForm.StationLineID, 1);
    },
    //混凝土配比物资选择
    recipeMatSelectChange(Id, index) {
      this.TrecipeSubList[index].MatGrade = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].MatGrade;
      this.TrecipeSubList[
        index
      ].MatTypeCode = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].MatClassTypeCode;
      this.TrecipeSubList[index].MatName = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].Name;
      this.TrecipeSubList[index].MatID = Id;
    }, //砂浆配比信息物资选择
    recipeMatSelectChangeS(Id, index) {
      this.SrecipeSubList[index].MatGrade = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].MatGrade;
      this.SrecipeSubList[
        index
      ].MatTypeCode = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].MatClassTypeCode;

      this.SrecipeSubList[index].MatName = this.baseData.MaterialList.filter(
        (x) => x.Id == Id
      )[0].Name;
      this.SrecipeSubList[index].MatID = Id;
    },
    //混凝土仓库选择
    recipeWhSelectChange(Id, index) {
      this.TrecipeSubList[index].WarehouseID = this.MappingList.filter(
        (x) => x.WarehouseID == Id
      )[0].WarehouseID;
      this.TrecipeSubList[index].WarehouseName = this.MappingList.filter(
        (x) => x.WarehouseID == Id
      )[0].WarehouseName;
    },
    //砂浆仓库选择
    recipeWhSelectChangeS(Id, index) {
      this.SrecipeSubList[index].WarehouseID = this.MappingList.filter(
        (x) => x.WarehouseID == Id
      )[0].WarehouseID;
      this.SrecipeSubList[index].WarehouseName = this.MappingList.filter(
        (x) => x.WarehouseID == Id
      )[0].WarehouseName;
    },
    queryData(params) {
      params.recipeType = this.openType;
      return getConsultRecipeListPage(params);
    },
    setVisible(val) {
      this.visibleDialog = val;
      if (!val) {
        this.visibleDiaInitQuery = null;
      }
    }, //混凝土回调理论配比
    dialogCallback(data) {
      if (data.length > 0) {
        this.getConsultRecipeDetailById(data[0].Id);
      }
      this.visibleDialog = false;
    },
    dialogType(type) {
      this.visibleDiaInitQuery = this.addForm.GradeName;
      this.visibleDialog = true;
      this.openType = type;
    },
    changeTquantity() {
      /* 
    砂率=砂/骨料、水胶比=水/粉料、F掺量=粉煤灰/粉料、K掺量=矿粉/粉料、A掺量=外加剂/粉料。 
    材料类型码：
    水：10，
    备用：20，
    骨料：30，砂子：301，石子：302
    粉料：40，水泥：401，粉煤灰：402，矿粉：403，
    外加剂：50
    */
      //-------- 计算比例 开始
      var warterTotal = 0; //水
      var sandTotal = 0; //砂
      var cementTotal = 0; //水泥
      var flyashTotal = 0; //粉煤灰
      var breezeTotal = 0; //矿粉
      var additiveTotal = 0; //外加剂
      var powderTotal = 0; //粉料
      var aggregateTotal = 0; //骨料
      var bulkDensity = 0; //容重

      this.TrecipeSubList.map((e) => {
        var matItem = this.baseData.MaterialList.filter(
          (k) => k.Id == e.MatID
        )[0];
        var quantity =
          e.ActualQuantity == "" || e.ActualQuantity == undefined
            ? 0
            : Number(e.ActualQuantity);
        bulkDensity += quantity;
        var typeCode =
          matItem != null && matItem != undefined
            ? matItem.MatClassTypeCode
            : "";
        if (typeCode == "") {
          return;
        } else {
          if (typeCode.indexOf("1") == 0) {
            warterTotal += Number(quantity);
          } else if (typeCode.indexOf("2") == 0) {
          } else if (typeCode.indexOf("3") == 0) {
            aggregateTotal += Number(quantity);

            if (typeCode == "301") {
              sandTotal += Number(quantity);
            }
          } else if (typeCode.indexOf("4") == 0) {
            powderTotal += Number(quantity);

            if (typeCode == "401") {
              cementTotal += Number(quantity);
            }
            if (typeCode == "402") {
              flyashTotal += Number(quantity);
            }
            if (typeCode == "403") {
              breezeTotal += Number(quantity);
            }
          } else if (typeCode.indexOf("5") == 0) {
            additiveTotal += Number(quantity);
          }
        }
      });
      this.addForm.TSL = (aggregateTotal == 0
        ? 0
        : sandTotal / aggregateTotal
      ).toFixed(4); //砂率
      this.addForm.TSJB = (powderTotal == 0
        ? 0
        : warterTotal / powderTotal
      ).toFixed(4); //水胶比
      this.addForm.TFProportion = (powderTotal == 0
        ? 0
        : flyashTotal / powderTotal
      ).toFixed(4); //F掺量
      this.addForm.TKProportion = (powderTotal == 0
        ? 0
        : breezeTotal / powderTotal
      ).toFixed(4); //K掺量
      this.addForm.TAProportion = (powderTotal == 0
        ? 0
        : additiveTotal / powderTotal
      ).toFixed(4); //A掺量
      this.addForm.TBulkDensity = bulkDensity;
    },
    changeSquantity() {
      /* 
    砂率=砂/骨料、水胶比=水/粉料、F掺量=粉煤灰/粉料、K掺量=矿粉/粉料、A掺量=外加剂/粉料。 
    材料类型码：
    水：10，
    备用：20，
    骨料：30，砂子：301，石子：302
    粉料：40，水泥：401，粉煤灰：402，矿粉：403，
    外加剂：50
    */
      //-------- 计算比例 开始
      var warterTotal = 0; //水
      var sandTotal = 0; //砂
      var cementTotal = 0; //水泥
      var flyashTotal = 0; //粉煤灰
      var breezeTotal = 0; //矿粉
      var additiveTotal = 0; //外加剂
      var powderTotal = 0; //粉料
      var aggregateTotal = 0; //骨料
      var bulkDensity = 0; //容重

      this.SrecipeSubList.map((e) => {
        var matItem = this.baseData.MaterialList.filter(
          (k) => k.Id == e.MatID
        )[0];
        var quantity =
          e.ActualQuantity == "" || e.ActualQuantity == undefined
            ? 0
            : Number(e.ActualQuantity);
        bulkDensity += quantity;
        var typeCode =
          matItem != null && matItem != undefined
            ? matItem.MatClassTypeCode
            : "";
        if (typeCode == "") {
          return;
        } else {
          if (typeCode.indexOf("1") == 0) {
            warterTotal += Number(quantity);
          } else if (typeCode.indexOf("2") == 0) {
          } else if (typeCode.indexOf("3") == 0) {
            aggregateTotal += Number(quantity);

            if (typeCode == "301") {
              sandTotal += Number(quantity);
            }
          } else if (typeCode.indexOf("4") == 0) {
            powderTotal += Number(quantity);

            if (typeCode == "401") {
              cementTotal += Number(quantity);
            }
            if (typeCode == "402") {
              flyashTotal += Number(quantity);
            }
            if (typeCode == "403") {
              breezeTotal += Number(quantity);
            }
          } else if (typeCode.indexOf("5") == 0) {
            additiveTotal += Number(quantity);
          }
        }
      });
      this.addForm.SSL = (aggregateTotal == 0
        ? 0
        : sandTotal / aggregateTotal
      ).toFixed(4); //砂率
      this.addForm.SSJB = (powderTotal == 0
        ? 0
        : warterTotal / powderTotal
      ).toFixed(4); //水胶比
      this.addForm.SFProportion = (powderTotal == 0
        ? 0
        : flyashTotal / powderTotal
      ).toFixed(4); //F掺量
      this.addForm.SKProportion = (powderTotal == 0
        ? 0
        : breezeTotal / powderTotal
      ).toFixed(4); //K掺量
      this.addForm.SAProportion = (powderTotal == 0
        ? 0
        : additiveTotal / powderTotal
      ).toFixed(4); //A掺量
      this.addForm.SBulkDensity = bulkDensity;
    },
    //混凝土配方明细添加行
    recipeTableAddRowT() {
      this.subIndex += 1;
      this.TrecipeSubList.push({
        Id: this.subIndex,
        IsManual: 1,
        RecipeType: 1,
      });
    },
    //砂浆配方明细添加行
    recipeTableAddRowS() {
      this.subIndex += 1;
      this.SrecipeSubList.push({
        Id: this.subIndex,
        IsManual: 1,
        RecipeType: 2,
      });
    },
    //混凝土配方明细删除行
    recipeTableRemoveRowT(id) {
      this.TrecipeSubList.splice(
        this.TrecipeSubList.findIndex((x) => x.Id === id),
        1
      );
    },
    //混凝土配方明细删除行
    recipeTableRemoveRowS(id) {
      this.SrecipeSubList.splice(
        this.SrecipeSubList.findIndex((x) => x.Id === id),
        1
      );
    },
    //混凝土类型选择
    recipeMappingSelectChangeT(Id, index) {
      var mappingItem = this.MappingList.filter((e) => e.MatClassID == Id)[0];
      this.$set(
        this.TrecipeSubList[index],
        "WarehouseID",
        mappingItem.WarehouseID
      );
      this.$set(
        this.TrecipeSubList[index],
        "WarehouseName",
        mappingItem.WarehouseName
      );
      this.$set(
        this.TrecipeSubList[index],
        "MatClassName",
        mappingItem.MatClassName
      );
      var matItem = this.baseData.MaterialList.filter(
        (e) => e.MatClassID == mappingItem.MatClassID
      )[0];
      this.$set(
        this.TrecipeSubList[index],
        "MatTypeCode",
        matItem.MatClassTypeCode
      );
      this.$set(this.TrecipeSubList[index], "MatID", matItem.Id);
      this.$set(this.TrecipeSubList[index], "MatName", matItem.Name);
      this.$set(this.TrecipeSubList[index], "MatGrade", matItem.MatGrade);
      this.$set(this.TrecipeSubList[index], "MatClassID", matItem.MatClassID);
    },
    //砂浆类型选择
    recipeMappingSelectChangeS(Id, index) {
      var mappingItem = this.MappingList.filter((e) => e.MatClassID == Id)[0];
      this.$set(
        this.SrecipeSubList[index],
        "WarehouseID",
        mappingItem.WarehouseID
      );
      this.$set(
        this.SrecipeSubList[index],
        "WarehouseName",
        mappingItem.WarehouseName
      );
      this.$set(
        this.SrecipeSubList[index],
        "MatClassName",
        mappingItem.MatClassName
      );
      var matItem = this.baseData.MaterialList.filter(
        (e) => e.MatClassID == mappingItem.MatClassID
      )[0];
      this.$set(
        this.SrecipeSubList[index],
        "MatTypeCode",
        matItem.MatClassTypeCode
      );
      this.$set(this.SrecipeSubList[index], "MatName", matItem.Name);
      this.$set(this.SrecipeSubList[index], "MatID", matItem.Id);
      this.$set(this.SrecipeSubList[index], "MatGrade", matItem.MatGrade);
      this.$set(this.SrecipeSubList[index], "MatClassID", matItem.MatClassID);
    },
    //砂浆计算含水率
    SMoistureContentCalculation() {
      var moistureContentCount = 0;
      //循环砂浆
      this.SrecipeSubList.map((e) => {
        var moistureContent = parseFloat(e.MoistureContent);
        moistureContent = moistureContent / 100;
        var typeCode = e.MatTypeCode;
        // 含水率:MoistureContent
        if (
          Number(typeCode) == 30 ||
          Number(typeCode) == 301 ||
          Number(typeCode) == 302
        ) {
          var Quantity = e.Quantity;
          if (moistureContent >= 1) {
            e.MoistureContent = 0;
            moistureContent = 0;
          }
          //实际用量 = 参考用量 /（1-含水率[小于1]）
          e.ActualQuantity = (Quantity / (1 - moistureContent)).toFixed(2);

          //水的重量 = 实际用量 * 含水率
          var ActualQuantity = e.ActualQuantity;
          moistureContentCount += moistureContent * ActualQuantity;
        }
      });

      var resultContent =
        "砂浆配方总含水为：" + moistureContentCount.toFixed(2);

      var _arrayList = new Array();
      this.SrecipeSubList.map((e) => {
        var TypeCode = e.MatTypeCode;
        if (Number(TypeCode) == 10) {
          var Quantity = parseFloat(e.Quantity);
          _arrayList.push(Quantity);
        }
      });
      if (_arrayList != null) {
        for (var i = 0; i < _arrayList.length; i++) {
          for (var u = i + 1; u < _arrayList.length; u++) {
            if (parseFloat(_arrayList[i]) > parseFloat(_arrayList[u])) {
              var num = [];
              num = _arrayList[i];
              _arrayList[i] = _arrayList[u];
              _arrayList[u] = num;
            }
          }
        }
        var index = 0;
        for (var j = _arrayList.length - 1; j >= 0; j--) {
          this.SrecipeSubList.map((e) => {
            var TypeCode = e.MatTypeCode;
            if (Number(moistureContentCount) > 0) {
              // 含水率:MoistureContent
              var Quantity = parseFloat(e.Quantity);
              //（清水）实际用量 = 参考用量 - （所有砂子石子中）水的重量
              if (
                Number(TypeCode) == 10 &&
                parseFloat(_arrayList[j]) == Quantity
              ) {
                var deductionWater = 0;
                //如果参考用量小于含水，则实际用量设置为0
                if (moistureContentCount > Quantity) {
                  moistureContentCount -= Quantity;
                  e.ActualQuantity = 0;
                  deductionWater = Quantity;
                } else {
                  var ActualQuantity = (
                    Quantity - moistureContentCount
                  ).toFixed(2);
                  deductionWater = moistureContentCount;
                  moistureContentCount = 0;
                  e.ActualQuantity = ActualQuantity;
                }
                resultContent +=
                  "仓库：" +
                  e.WarehouseName +
                  "-物资:" +
                  e.MatName +
                  "扣水" +
                  deductionWater.toFixed(2);
                _arrayList[j] = -1;
              }
            } else if (Number(TypeCode) == 10) {
              e.ActualQuantity = e.Quantity;
            }
          });
        }
      }
      if (moistureContentCount > 0) {
        this.$message({
          message: "待扣水：" + moistureContentCount.toFixed(2),
          type: "warning",
        });
      }
      this.$message({
        message: resultContent,
        type: "success",
      });
    },
    //混凝土计算含水率
    TMoistureContentCalculation() {
      var moistureContentCount = 0;
      //循环砂浆
      this.TrecipeSubList.map((e) => {
        var moistureContent = parseFloat(e.MoistureContent);
        moistureContent = moistureContent / 100;
        var typeCode = e.MatTypeCode;
        // 含水率:MoistureContent
        if (
          Number(typeCode) == 30 ||
          Number(typeCode) == 301 ||
          Number(typeCode) == 302
        ) {
          var Quantity = e.Quantity;
          if (moistureContent >= 1) {
            e.MoistureContent = 0;
            moistureContent = 0;
          }
          //实际用量 = 参考用量 /（1-含水率[小于1]）
          e.ActualQuantity = (Quantity / (1 - moistureContent)).toFixed(2);

          //水的重量 = 实际用量 * 含水率
          var ActualQuantity = e.ActualQuantity;
          moistureContentCount += moistureContent * ActualQuantity;
        }
      });

      var resultContent =
        "混凝土配方总含水为：" + moistureContentCount.toFixed(2);

      var _arrayList = new Array();
      this.TrecipeSubList.map((e) => {
        var TypeCode = e.MatTypeCode;
        if (Number(TypeCode) == 10) {
          var Quantity = parseFloat(e.Quantity);
          _arrayList.push(Quantity);
        }
      });
      if (_arrayList != null) {
        for (var i = 0; i < _arrayList.length; i++) {
          for (var u = i + 1; u < _arrayList.length; u++) {
            if (parseFloat(_arrayList[i]) > parseFloat(_arrayList[u])) {
              var num = [];
              num = _arrayList[i];
              _arrayList[i] = _arrayList[u];
              _arrayList[u] = num;
            }
          }
        }
        for (var j = _arrayList.length - 1; j >= 0; j--) {
          this.TrecipeSubList.map((e) => {
            var TypeCode = e.MatTypeCode;
            if (Number(moistureContentCount) > 0) {
              // 含水率:MoistureContent
              var Quantity = parseFloat(e.Quantity);
              //（清水）实际用量 = 参考用量 - （所有砂子石子中）水的重量
              if (
                Number(TypeCode) == 10 &&
                parseFloat(_arrayList[j]) == Quantity
              ) {
                var deductionWater = 0;
                //如果参考用量小于含水，则实际用量设置为0
                if (moistureContentCount > Quantity) {
                  moistureContentCount -= Quantity;
                  e.ActualQuantity = 0;
                  deductionWater = Quantity;
                } else {
                  var ActualQuantity = (
                    Quantity - moistureContentCount
                  ).toFixed(2);
                  deductionWater = moistureContentCount;
                  moistureContentCount = 0;
                  e.ActualQuantity = ActualQuantity;
                }
                resultContent +=
                  "仓库：" +
                  e.WarehouseName +
                  "-物资:" +
                  e.MatName +
                  "扣水" +
                  deductionWater.toFixed(2);
                _arrayList[j] = -1;
              }
            } else if (Number(TypeCode) == 10) {
              e.ActualQuantity = e.Quantity;
            }
          });
        }
      }
      if (moistureContentCount > 0) {
        this.$message({
          message: "混凝土待扣水：" + moistureContentCount.toFixed(2),
          type: "warning",
        });
      }
      this.$message({
        message: resultContent,
        type: "success",
      });
    },
    //获取生产线列表
    getSysStationLineList() {
      let para = {
        key: this.orgId,
      };
      this.listLoading = true;
      getSysStationLineListPage(para)
        .then((res) => {
          this.stationLine = res.data.response.data;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 显示绑定弹窗
    showBandData(id, dm) {
      // var taskIds = "";
      this.recipeTitle = dm.row.Title;
      this.recipeid = id;
      this.isShowBandData = !this.isShowBandData;
    },
    bindRecipeSubmit() {
      let para = {
        taskIds: this.taskIds,
        recipeId: this.recipeid,
      };
      sendTask(para).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getGetRecipeTask();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.listLoading = false;
        this.isShowBandData = !this.isShowBandData;
        // this.selectProdRecipeRow = "";
      });
    },
    sendRecipeFunc() {
      let para = {
        recipeId: this.currentRow.Id,
        orgId: this.orgId,
      };
      this.listLoading = true;
      sendRecipe(para).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getSysStationLineListPage(true);
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.listLoading = false;
      });
    },
  },
};
</script>

<style lang="less"></style>
